import { BrowserRouter as Router, Switch } from "react-router-dom";
import Routes from "./Routes";
import { ConfigProvider } from "antd";
import React, { Component } from "react";
import "./antd.css";
import "./scss/app.scss";
import "./scss/responsive.scss";
import {
  setCurrentLang,
  setMetaData,
  setNotificationList,
} from "./redux/user/user.action";
import { connect } from "react-redux";
import {
  GetMetaData,
  GetAllNotification,
  AddPushToken,
} from "./network/home.network";
import { onMessageListener, requestForToken } from "./firebase";
class App extends Component {
  //   switchLang = () => {
  //     localStorage.setItem('lang', lang === 'en' ? 'ar' : 'en');
  //     window.location.reload();
  // }

  componentDidMount() {
    this.handelAddNotification();
    GetAllNotification(
      (res) => {
        this.props.dispatch(setNotificationList(res?.data?.model));
        // audioTune.play();
      },
      (err) => {}
    );
    onMessageListener((payload) => {
      console.log(payload);
      // const audioTune = new Audio(audio);
      // console.log(audioTune)
      GetAllNotification(
        (res) => {
          this.props.dispatch(setNotificationList(res?.data?.model));
          // audioTune.play();
        },
        (err) => {}
      );
    });

    GetMetaData(
      (res) => {
        //console.log(res.data.model)
        this.props.dispatch(setMetaData(res.data.model));
      },
      (err) => {
        //console.log(err)
      }
    );

    if (!this.props.currentLang) {
      //console.log(this.props.currentLang);
      localStorage.setItem("lang", "ar");
      document.getElementsByTagName("html")[0].setAttribute("lang", "ar");
      this.props.dispatch(setCurrentLang("ar"));
    } else {
      //console.log(this.props.currentLang, "change");
      // this.props.dispatch(setCurrentLang("en"));
      document
        .getElementsByTagName("html")[0]
        .setAttribute("lang", this.props.currentLang);
    }
  }

  handelAddNotification = async () => {
    const userToken = await requestForToken();
    let body = {
      Token: userToken,
      OS: "WEB",
    };
    console.log(userToken);
    AddPushToken(
      body,
      (res) => {
        // console.log(res)
      },
      (err) => {
        console.log(err);
      }
    );
  };

  render() {
    const { currentLang } = this.props;
    return (
      <div className="app">
        <ConfigProvider direction={currentLang === "en" ? "ltr" : "rtl"}>
          <Router>
            <Switch>
              <Routes />
            </Switch>
          </Router>
        </ConfigProvider>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  currentLang: state.user.currentLang,
});

export default connect(mapStateToProps)(App);
